import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppLoadingService } from '../loading/app-loading.service';
import { NG_HTTP_LOADER_FILTERED_URL_PATTERNS } from '../environments/ng-http-loader.config';

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  private readonly loading = inject(AppLoadingService);
  private readonly patterns = NG_HTTP_LOADER_FILTERED_URL_PATTERNS.map(
    pattern => new RegExp(pattern, 'i')
  );

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.isFiltered(req.url)) {
      return next.handle(req);
    }
    this.loading.trackHttpStart();
    return next.handle(req).pipe(
      finalize(() => this.loading.trackHttpEnd())
    );
  }

  private isFiltered(url: string): boolean {
    return this.patterns.some(pattern => pattern.test(url));
  }
}
